import fetch from "auth/FetchInterceptor";

const SubscriptionService = {};
const prefix = "/subscription";

SubscriptionService.getSubscriptions = async ({
  page = 1,
  limit = 10,
  search,
  status,
} = {}) =>
  await fetch(`${prefix}/getAll`, {
    method: "GET",
    params: {
      page,
      limit,
      ...(search ? { search } : {}),
      ...(status ? { status } : {}),
    },
  });

SubscriptionService.getSubscriptionById = async (id) =>
  await fetch(`${prefix}/getById/${id}`, {
    method: "GET",
  });

SubscriptionService.createSubscription = async (data) =>
  await fetch(`${prefix}/create`, {
    method: "POST",
    data,
  });

SubscriptionService.updateSubscription = async (id, data) =>
  await fetch(`${prefix}/update/${id}`, {
    method: "PUT",
    data,
  });

SubscriptionService.deleteSubscription = async (id) =>
  await fetch(`${prefix}/deleteById/${id}`, {
    method: "DELETE",
  });

SubscriptionService.updateSubscriptionStatus = async (id, status) =>
  await fetch(`${prefix}/updateStatus/${id}`, {
    method: "PUT",
    data: { status },
  });

/**
 * Traduit le contenu d'un pack depuis une langue source vers les autres.
 * `content` ne doit contenir que la langue source (pas l'objet {fr,en,ar}).
 * Réponse : { status, source, targets, translations: { en, ar }, en, ar }
 */
SubscriptionService.translate = async ({
  content,
  source = "fr",
  targets = ["en", "ar"],
}) =>
  await fetch(`/translate`, {
    method: "POST",
    data: { source, targets, content },
  });

SubscriptionService.getEligibleFormations = async () =>
  await fetch(`${prefix}/eligible-formations`, {
    method: "GET",
  });

export default SubscriptionService;
